export const SwiftypeAPI = function(apiConfig, http, helpers) {
  let self = this;
  let path = `${process.env.BASENAME}/app/api/web`;

  self.swiftypeSearch = (collection, engineName, query, filters=null, analytics=null, pagination=null, sort=null) => {
    return http.get(`${path}/${collection}/swiftype/search`, {
      params: {
        engineName,
        query,
        filters,
        analytics,
        sort,
        ...pagination ? {pagination} : {}
      }
    });
  }

  self.swiftypeClickThrough = (collection, engineName, params) => {
    return http.post(`${path}/${collection}/swiftype/clickThrough`,
      {
        engineName,
        params
      }
    );
  }

}
